import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-20 px-4 max-w-3xl mx-auto" data-id="element-191">
      <h2 className="font-serif text-3xl md:text-4xl text-brown font-bold text-center mb-12" data-id="element-192">
        ¿Te pasa esto?
      </h2>

      <div className="space-y-6 mb-12" data-id="element-193">
        {['Te despertás y la primera voz que escuchás es la tuya diciéndote que no alcanza.', 'Lográs algo y, en vez de disfrutarlo, ya estás pensando en lo que te falta.', 'Abrís el celular, ves la vida de otros y terminás sintiéndote menos.', 'Sabés que valés… pero por dentro te tratás como no tratarías ni a tu peor enemigo.'].map((point, i) => <motion.div key={i} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="flex items-start gap-4 bg-white/60 p-6 rounded-2xl border border-gold/10" data-id="element-194">
            <div className="w-2 h-2 rounded-full bg-gold mt-2.5 shrink-0" data-id="element-195" />
            <p className="font-sans text-lg text-brown/90 leading-relaxed" data-id="element-196">
              {point}
            </p>
          </motion.div>)}
      </div>

      <div className="text-center space-y-6" data-id="element-197">
        <p className="font-sans text-lg text-brown/90 leading-relaxed" data-id="element-198">
          No sos débil. Nunca te enseñaron a hablarte bien. Esa voz, repetida
          todos los días, está construyendo la vida que tenés hoy.
        </p>
        <p className="font-serif text-2xl text-gold font-bold" data-id="element-199">
          ¿Cuántos meses más vas a dejar que esa voz decida por vos?
        </p>
      </div>
    </section>;
}